import { Component, Input } from '@angular/core';
import { UsuarioProvider } from 'src/app/providers/usuario.provider';

@Component({
    selector: 'localidade-uf-municipio',
    templateUrl: './localidade-uf-municipio.component.html',
    styleUrls: ['./localidade-uf-municipio.component.scss'],
})
export class LocalidadeUfMunicipioComponent {

    @Input() darkMode: boolean;
    @Input() localidade: any;
    @Input() isEstadual: boolean;
    @Input() showArrow: boolean;
    @Input() selecionado: boolean;

    constructor(
        public usuarioProvider: UsuarioProvider
    ) {}
}
